module.exports = __webpack_public_path__ + "img/favicon-atu.da55bbc5.png";